(function() { window.GUID_56c939e7_6995_4008_a46a_f410abb72455 = { getGuid: function() { return "56c939e7-6995-4008-a46a-f410abb72455"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let LayoutType;
        (function (LayoutType) {
            LayoutType[LayoutType["Cards"] = 0] = "Cards";
            LayoutType[LayoutType["Grid"] = 1] = "Grid";
        })(LayoutType = Enumeration.LayoutType || (Enumeration.LayoutType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=LayoutType.pre.js.map
